/**Multiselector de varias guias */
import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { toSelected } from "./logic";
import { columnas } from "./columns";


export interface Props {
    /**Id de las guías seleccionadas seleccionados */
    value: number[];
    idGuiasYaIncluidas: number[];
    onChange: (value: number[]) => void;
    items: models.GuiaDTO[];
    hideBusqueda?: boolean;
    label?: string;
}

/**Multiselector de guias, lo unico que muestra es el grid, no muestra los filtros ni ninguna otra cosa  */
class MultiselectorGuiasListNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    idGuiasYaIncluidas = (props: Props) => props.idGuiasYaIncluidas;
    items = (props: Props) => props.items;
    itemsFiltrados = createSelectorRx(this.items, this.idGuiasYaIncluidas, (items, idGuiasYaIncluidas) => items != null ? items.filter(x => idGuiasYaIncluidas.indexOf(x.IdRegistro) == -1) : []);
    itemsSelected = createSelectorRx(this.value, this.itemsFiltrados, (value, items) => toSelected(items, value));

    onSeleccionar = (guia: models.GuiaDTO, selected: boolean) => {
        const old = this.value(this.props);
        const next = selected ? [...old, guia.IdRegistro] : old.filter(x => x != guia.IdRegistro);
        this.props.onChange(next);
    };

    render() {
        const cols = columnas(this);
        return (
            <div>
                {this.props.label && <kea.Title titulo={this.props.label} size="h4" />}
                <kea.Grid2 cookieKey="multiselectorGuiasDescargaZE" items={this.itemsSelected(this.props)} columnas={cols} hideBusqueda={this.props.hideBusqueda} />
            </div>
        );
    }
}

export const MultiselectorGuiasList = componentToRx(MultiselectorGuiasListNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/descargaze/edit/multiselector/multiselectorguias.tsx